"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.grayScale = void 0;
exports.grayScale = {
    white: "#FFFFFF",
    gray0: "#F6F9FA",
    gray5: "#F2F6F8",
    gray10: "#EEF3F6",
    gray20: "#E4EBF0",
    gray30: "#D7E0E6",
    gray40: "#C7D2D8",
    gray50: "#B4BFC6",
    gray60: "#9DA7AE",
    gray70: "#81898F",
    gray80: "#5F666B",
    gray90: "#3A3E41",
    gray100: "#141617",
    black: "#000000",
};
//# sourceMappingURL=grayScale.js.map